export default __webpack_public_path__ + "static/media/comfortable.d5d04e36.webp";